"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CleanIcon = function () { return (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M5.33073 15.8333L4.16406 14.6667L8.83073 9.99999L4.16406 5.33332L5.33073 4.16666L9.9974 8.83332L14.6641 4.16666L15.8307 5.33332L11.1641 9.99999L15.8307 14.6667L14.6641 15.8333L9.9974 11.1667L5.33073 15.8333Z" }))); };
exports.default = CleanIcon;
